import { Injectable } from '@angular/core';
import { AxiosService } from 'src/app/core/axios';
import { CiteDTO } from 'src/app/shared/dto/cite.dto';
import { ResponseCodeDTO } from 'src/app/shared/dto/response-codes.dto';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  constructor(private readonly axiosService: AxiosService) {
    // do nothing
  }

  async getCites(): Promise<CiteDTO[]> {
    const result: ResponseCodeDTO = await this.axiosService.get('/user/cites');
    return result.code.code === 'PTZ0000' ? result.data : [];
  }
}
